var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import GlobalVue from "../../globalVue";
import TakeStockService from '../../api/TakeStockService';
import { UrlHelper } from "../../helper/UrlWrapper";
import Add from './Add';
import Detail from './Detail';
import Header from "./components/Header.vue";
import AreaShop from "@/components/AreaShop";
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import CommonService from "../../api/CommonService";
var PurchaseList = (function (_super) {
    __extends(PurchaseList, _super);
    function PurchaseList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        return _this;
    }
    PurchaseList.prototype.created = function () {
        this.service = TakeStockService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PurchaseList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    PurchaseList.prototype.operateCommand = function (command) {
        switch (command) {
            case 2:
                this.exportData();
                break;
            case 3:
                this.discard();
                break;
        }
    };
    PurchaseList.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.selectRows.map(function (item) {
            return item.order_id;
        }) || [];
        var params = {
            order_ids: orderIds.join(",")
        };
        this.service.stockExport(params).then(function (res) {
            if (res.data.success) {
                if (res.data.code == 66) {
                    _this.$message.success(res.data.msg || '导出数据量超过1万条时，将通过异步方式生成下载链接，请注意查看系统消息');
                }
                else {
                    _this.exportDataOne(orderIds);
                }
            }
        }).catch(function (err) {
            console.log(err);
        });
    };
    PurchaseList.prototype.exportDataOne = function (orderIds) {
        var url = "supplierclientapi/inventoryorder/export_detail?&order_ids=" + orderIds;
        url = UrlHelper.addParam(url, "is_export", '1');
        url = UrlHelper.addParam(url, "token", this.user.token);
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        location.href = url;
        window._czc.push(["_trackEvent", '盘点单导出', '盘点单导出']);
    };
    PurchaseList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        this.filter.depot_ids = (this.filter.depot_ids || []).join(',');
        this.getList();
    };
    PurchaseList.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(Object.assign({}, this.filter, __assign({}, pager, { sort_field: this.order ? this.order[0] : null, sort_type: this.order ? this.order[1] : null }))).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PurchaseList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PurchaseList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PurchaseList.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加盘点单',
            showExist: true,
            name: 'takeStock_add',
            cprops: {}
        });
    };
    PurchaseList.prototype.edit = function (row) {
        this.addTab({
            component: Add,
            title: '修改盘点单',
            showExist: true,
            name: 'takeStock_edit' + row.order_id,
            cprops: {
                orderid: row.order_id
            }
        });
    };
    PurchaseList.prototype.check = function (row) {
        this.addTab({
            component: Detail,
            title: '盘点单详情',
            showExist: true,
            name: 'takeStock_check' + row.order_id,
            cprops: {
                orderid: row.order_id
            }
        });
    };
    PurchaseList.prototype.audit = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("审核后不可修改，并据此更新库存。请确认是否继续？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.audit({
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                    return;
                }
                else if (res.data.code !== 0) {
                    var html = "<div>" + res.data.msg + "</div>";
                    _this.$confirm(html, '提示', {
                        dangerouslyUseHTMLString: true,
                        customClass: 'confirm',
                        confirmButtonText: '知道了',
                        showCancelButton: false,
                    }).catch(function (err) {
                        console.log(err);
                    });
                    return;
                }
                _this.$message.success("审核成功");
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.discard = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("请确认是否废弃选中的单据？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.discard({
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                }
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PurchaseList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            if (prop == 'order_status_name') {
                prop = 'order_status';
            }
            this.order = [prop, order === 'ascending' ? 'ASC' : 'DESC'];
        }
        this.getList();
    };
    PurchaseList.prototype.editStore = function (row) {
    };
    PurchaseList.prototype.resetData = function () {
    };
    PurchaseList = __decorate([
        auth(nameDict["盘点"], true),
        Component({
            computed: __assign({}, mapGetters({
                "user": "user",
                openedCodeData: 'openedCodeData'
            })),
            components: {
                'list-header': Header,
                "areaShop": AreaShop
            }
        })
    ], PurchaseList);
    return PurchaseList;
}(Vue));
export default PurchaseList;
